/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Equipment Service API
 * Equipment management service for CTE platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BatchDeleteEquipmentRequestDTO,
  BatchDeleteEquipmentResponseDTO,
  CertificateLookupAccepted,
  CountEquipmentForDocumentsParams,
  CountEquipmentForDocumentsResponse,
  CreateEquipmentDTO,
  EquipmentBatchUploadDTO,
  EquipmentDTO,
  EquipmentFieldMetadataListDTO,
  EquipmentListResponseDTO,
  EquipmentSummaryResponseDTO,
  ErrorResponse,
  FindLinkCandidatesParams,
  FindLinkCandidatesResponse,
  GetEquipmentSummaryParams,
  ListEquipmentBatchUploadsParams,
  ListEquipmentForDocumentParams,
  ListEquipmentForDocumentResponse,
  ListEquipmentParams,
  ListLinkPickerEquipmentParams,
  ListLinkPickerEquipmentResponse,
  ListRecentDocumentLinksParams,
  ListRecentDocumentLinksResponse,
  PatchEquipmentDTO,
  PurgeSiteEquipmentResponseDTO,
  RequestCertificateLookupParams,
  SetEquipmentScheduleRuleRequest,
  SiteAreaDTO,
  SweepUpcomingInspectionsRequest,
  SweepUpcomingInspectionsResponse,
  UpsertSiteAreaRequest,
  ValidationErrorResponse
} from './model';

import { customFetch } from './custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListEquipmentUrl = (params: ListEquipmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment?${stringifiedParams}` : `/api/equipment`
}

/**
 * **Auth:** viewer floor + site claim on `siteId`. Admin bypasses the
 * site-claim check.
 * @summary List equipment with pagination
 */
export const listEquipment = async (params: ListEquipmentParams, options?: RequestInit): Promise<EquipmentListResponseDTO> => {

  return customFetch<EquipmentListResponseDTO>(getListEquipmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEquipmentInfiniteQueryKey = (params?: ListEquipmentParams,) => {
    return [
    'infinite', `/api/equipment`, ...(params ? [params] : [])
    ] as const;
    }

export const getListEquipmentQueryKey = (params?: ListEquipmentParams,) => {
    return [
    `/api/equipment`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEquipmentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listEquipment>>, ListEquipmentParams['offset']>, TError = ErrorResponse>(params: ListEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData, QueryKey, ListEquipmentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEquipmentInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEquipment>>, QueryKey, ListEquipmentParams['offset']> = ({ signal, pageParam }) => listEquipment({...params, 'offset': pageParam ?? params?.['offset']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData, QueryKey, ListEquipmentParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEquipmentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listEquipment>>>
export type ListEquipmentInfiniteQueryError = ErrorResponse


export function useListEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipment>>, ListEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData, QueryKey, ListEquipmentParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipment>>,
          TError,
          Awaited<ReturnType<typeof listEquipment>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipment>>, ListEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData, QueryKey, ListEquipmentParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipment>>,
          TError,
          Awaited<ReturnType<typeof listEquipment>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipment>>, ListEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData, QueryKey, ListEquipmentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List equipment with pagination
 */

export function useListEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipment>>, ListEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData, QueryKey, ListEquipmentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEquipmentInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof listEquipment>>, TError = ErrorResponse>(params: ListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEquipment>>> = ({ signal }) => listEquipment(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof listEquipment>>>
export type ListEquipmentQueryError = ErrorResponse


export function useListEquipment<TData = Awaited<ReturnType<typeof listEquipment>>, TError = ErrorResponse>(
 params: ListEquipmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipment>>,
          TError,
          Awaited<ReturnType<typeof listEquipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipment<TData = Awaited<ReturnType<typeof listEquipment>>, TError = ErrorResponse>(
 params: ListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipment>>,
          TError,
          Awaited<ReturnType<typeof listEquipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipment<TData = Awaited<ReturnType<typeof listEquipment>>, TError = ErrorResponse>(
 params: ListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List equipment with pagination
 */

export function useListEquipment<TData = Awaited<ReturnType<typeof listEquipment>>, TError = ErrorResponse>(
 params: ListEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateEquipmentUrl = () => {




  return `/api/equipment`
}

/**
 * @summary Create a new equipment record
 */
export const createEquipment = async (createEquipmentDTO: CreateEquipmentDTO, options?: RequestInit): Promise<EquipmentDTO> => {

  return customFetch<EquipmentDTO>(getCreateEquipmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEquipmentDTO)
  }
);}





export const getCreateEquipmentMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEquipment>>, TError,{data: CreateEquipmentDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEquipment>>, TError,{data: CreateEquipmentDTO}, TContext> => {

const mutationKey = ['createEquipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEquipment>>, {data: CreateEquipmentDTO}> = (props) => {
          const {data} = props ?? {};

          return  createEquipment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEquipmentMutationResult = NonNullable<Awaited<ReturnType<typeof createEquipment>>>
    export type CreateEquipmentMutationBody = CreateEquipmentDTO
    export type CreateEquipmentMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Create a new equipment record
 */
export const useCreateEquipment = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEquipment>>, TError,{data: CreateEquipmentDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEquipment>>,
        TError,
        {data: CreateEquipmentDTO},
        TContext
      > => {
      return useMutation(getCreateEquipmentMutationOptions(options), queryClient);
    }

export const getRequestCertificateLookupUrl = (id: string,
    params?: RequestCertificateLookupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/${id}/certificate-lookup?${stringifiedParams}` : `/api/equipment/${id}/certificate-lookup`
}

/**
 * Asks iecex-svc for the certificate named on this equipment record and
 * attaches the resulting PDF to every tag at the site sharing it.
 *
 * The request body is empty on purpose. The certificate number comes from
 * the equipment record, and the tags it covers are derived here from the
 * register — neither is accepted from the caller. A request that could
 * name the tags could attach a certificate to equipment it does not own,
 * or to equipment that does not carry that certificate, which would
 * manufacture compliance evidence the register does not support.
 *
 * Returns 202 when the work is queued, or 200 when every covered tag
 * already holds a certificate and nothing was requested — the projection
 * of attached documents is already local, so a certificate we hold costs
 * nothing to recognise and re-fetching it would spend a request on a
 * public API we do not run to arrive at a file we already have. Pass
 * `?force=true` to fetch anyway.
 *
 * Fetching from IECEx is rate limited, so a burst of requests serialises
 * rather than being answered inline. The attached document arrives on the
 * equipment's documents once it lands.
 * @summary Fetch this equipment's IECEx certificate and attach it
 */
export const requestCertificateLookup = async (id: string,
    params?: RequestCertificateLookupParams, options?: RequestInit): Promise<CertificateLookupAccepted> => {

  return customFetch<CertificateLookupAccepted>(getRequestCertificateLookupUrl(id,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestCertificateLookupMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCertificateLookup>>, TError,{id: string;params?: RequestCertificateLookupParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestCertificateLookup>>, TError,{id: string;params?: RequestCertificateLookupParams}, TContext> => {

const mutationKey = ['requestCertificateLookup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCertificateLookup>>, {id: string;params?: RequestCertificateLookupParams}> = (props) => {
          const {id,params} = props ?? {};

          return  requestCertificateLookup(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestCertificateLookupMutationResult = NonNullable<Awaited<ReturnType<typeof requestCertificateLookup>>>

    export type RequestCertificateLookupMutationError = ErrorResponse

    /**
 * @summary Fetch this equipment's IECEx certificate and attach it
 */
export const useRequestCertificateLookup = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCertificateLookup>>, TError,{id: string;params?: RequestCertificateLookupParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestCertificateLookup>>,
        TError,
        {id: string;params?: RequestCertificateLookupParams},
        TContext
      > => {
      return useMutation(getRequestCertificateLookupMutationOptions(options), queryClient);
    }

export const getGetEquipmentByIdUrl = (id: string,) => {




  return `/api/equipment/${id}`
}

/**
 * **Auth:** viewer floor + site claim on the loaded record's site.
 * Admin bypasses the site-claim check. The claim check runs after the
 * record is loaded so callers cannot probe IDs across sites.
 * @summary Get equipment by ID
 */
export const getEquipmentById = async (id: string, options?: RequestInit): Promise<EquipmentDTO> => {

  return customFetch<EquipmentDTO>(getGetEquipmentByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquipmentByIdQueryKey = (id: string,) => {
    return [
    `/api/equipment/${id}`
    ] as const;
    }


export const getGetEquipmentByIdQueryOptions = <TData = Awaited<ReturnType<typeof getEquipmentById>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquipmentByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquipmentById>>> = ({ signal }) => getEquipmentById(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquipmentById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquipmentByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEquipmentById>>>
export type GetEquipmentByIdQueryError = ErrorResponse


export function useGetEquipmentById<TData = Awaited<ReturnType<typeof getEquipmentById>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquipmentById>>,
          TError,
          Awaited<ReturnType<typeof getEquipmentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquipmentById<TData = Awaited<ReturnType<typeof getEquipmentById>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquipmentById>>,
          TError,
          Awaited<ReturnType<typeof getEquipmentById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquipmentById<TData = Awaited<ReturnType<typeof getEquipmentById>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get equipment by ID
 */

export function useGetEquipmentById<TData = Awaited<ReturnType<typeof getEquipmentById>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentById>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquipmentByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPatchEquipmentUrl = (id: string,) => {




  return `/api/equipment/${id}`
}

/**
 * @summary Partially update equipment by ID
 */
export const patchEquipment = async (id: string,
    patchEquipmentDTO: PatchEquipmentDTO, options?: RequestInit): Promise<EquipmentDTO> => {

  return customFetch<EquipmentDTO>(getPatchEquipmentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchEquipmentDTO)
  }
);}





export const getPatchEquipmentMutationOptions = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEquipment>>, TError,{id: string;data: PatchEquipmentDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchEquipment>>, TError,{id: string;data: PatchEquipmentDTO}, TContext> => {

const mutationKey = ['patchEquipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEquipment>>, {id: string;data: PatchEquipmentDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEquipment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchEquipmentMutationResult = NonNullable<Awaited<ReturnType<typeof patchEquipment>>>
    export type PatchEquipmentMutationBody = PatchEquipmentDTO
    export type PatchEquipmentMutationError = ErrorResponse | ValidationErrorResponse

    /**
 * @summary Partially update equipment by ID
 */
export const usePatchEquipment = <TError = ErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEquipment>>, TError,{id: string;data: PatchEquipmentDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEquipment>>,
        TError,
        {id: string;data: PatchEquipmentDTO},
        TContext
      > => {
      return useMutation(getPatchEquipmentMutationOptions(options), queryClient);
    }

export const getDeleteEquipmentUrl = (id: string,) => {




  return `/api/equipment/${id}`
}

/**
 * @summary Delete equipment by ID
 */
export const deleteEquipment = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteEquipmentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteEquipmentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEquipment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEquipment>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteEquipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEquipment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEquipment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEquipmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEquipment>>>

    export type DeleteEquipmentMutationError = ErrorResponse

    /**
 * @summary Delete equipment by ID
 */
export const useDeleteEquipment = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEquipment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEquipment>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteEquipmentMutationOptions(options), queryClient);
    }

export const getSweepUpcomingInspectionsUrl = () => {




  return `/api/equipment/schedule-sweep`
}

/**
 * Recomputes the schedule of every tag at the site and publishes
 * `equipment.inspection.due` for each tag whose set of inspections due
 * inside the site's outlook changed (rubics-code/cte#2027). inspection-svc
 * keeps one UPCOMING inspection per listed clock and cancels the rest.
 * The service runs the same sweep once a day and after each schedule
 * save; this endpoint runs it now.
 * The sweep publishes only the tags whose set changed, and every tag
 * again once a week; `force` publishes every tag now.
 *
 * **Auth:** manager floor (manager or admin) + site claim.
 * @summary Run the upcoming inspection sweep for a site
 */
export const sweepUpcomingInspections = async (sweepUpcomingInspectionsRequest: SweepUpcomingInspectionsRequest, options?: RequestInit): Promise<SweepUpcomingInspectionsResponse> => {

  return customFetch<SweepUpcomingInspectionsResponse>(getSweepUpcomingInspectionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sweepUpcomingInspectionsRequest)
  }
);}





export const getSweepUpcomingInspectionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sweepUpcomingInspections>>, TError,{data: SweepUpcomingInspectionsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sweepUpcomingInspections>>, TError,{data: SweepUpcomingInspectionsRequest}, TContext> => {

const mutationKey = ['sweepUpcomingInspections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sweepUpcomingInspections>>, {data: SweepUpcomingInspectionsRequest}> = (props) => {
          const {data} = props ?? {};

          return  sweepUpcomingInspections(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SweepUpcomingInspectionsMutationResult = NonNullable<Awaited<ReturnType<typeof sweepUpcomingInspections>>>
    export type SweepUpcomingInspectionsMutationBody = SweepUpcomingInspectionsRequest
    export type SweepUpcomingInspectionsMutationError = void

    /**
 * @summary Run the upcoming inspection sweep for a site
 */
export const useSweepUpcomingInspections = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sweepUpcomingInspections>>, TError,{data: SweepUpcomingInspectionsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sweepUpcomingInspections>>,
        TError,
        {data: SweepUpcomingInspectionsRequest},
        TContext
      > => {
      return useMutation(getSweepUpcomingInspectionsMutationOptions(options), queryClient);
    }

export const getSetEquipmentScheduleRuleUrl = (id: string,) => {




  return `/api/equipment/${id}/schedule-rule`
}

/**
 * Expert advice for one tag (docs/plans/inspection-schedule.md). The rule
 * beats the zone row until it expires, and the site limits
 * still clamp it. The service stamps who approved it and when.
 *
 * **Auth:** manager floor (manager or admin) + site claim.
 * @summary Set a tag's own schedule rule
 */
export const setEquipmentScheduleRule = async (id: string,
    setEquipmentScheduleRuleRequest: SetEquipmentScheduleRuleRequest, options?: RequestInit): Promise<EquipmentDTO> => {

  return customFetch<EquipmentDTO>(getSetEquipmentScheduleRuleUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setEquipmentScheduleRuleRequest)
  }
);}





export const getSetEquipmentScheduleRuleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEquipmentScheduleRule>>, TError,{id: string;data: SetEquipmentScheduleRuleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setEquipmentScheduleRule>>, TError,{id: string;data: SetEquipmentScheduleRuleRequest}, TContext> => {

const mutationKey = ['setEquipmentScheduleRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setEquipmentScheduleRule>>, {id: string;data: SetEquipmentScheduleRuleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  setEquipmentScheduleRule(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetEquipmentScheduleRuleMutationResult = NonNullable<Awaited<ReturnType<typeof setEquipmentScheduleRule>>>
    export type SetEquipmentScheduleRuleMutationBody = SetEquipmentScheduleRuleRequest
    export type SetEquipmentScheduleRuleMutationError = void

    /**
 * @summary Set a tag's own schedule rule
 */
export const useSetEquipmentScheduleRule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEquipmentScheduleRule>>, TError,{id: string;data: SetEquipmentScheduleRuleRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setEquipmentScheduleRule>>,
        TError,
        {id: string;data: SetEquipmentScheduleRuleRequest},
        TContext
      > => {
      return useMutation(getSetEquipmentScheduleRuleMutationOptions(options), queryClient);
    }

export const getClearEquipmentScheduleRuleUrl = (id: string,) => {




  return `/api/equipment/${id}/schedule-rule`
}

/**
 * Removes the tag rule so the zone rows apply again.
 *
 * **Auth:** manager floor (manager or admin) + site claim.
 * @summary Clear a tag's own schedule rule
 */
export const clearEquipmentScheduleRule = async (id: string, options?: RequestInit): Promise<EquipmentDTO> => {

  return customFetch<EquipmentDTO>(getClearEquipmentScheduleRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearEquipmentScheduleRuleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearEquipmentScheduleRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearEquipmentScheduleRule>>, TError,{id: string}, TContext> => {

const mutationKey = ['clearEquipmentScheduleRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearEquipmentScheduleRule>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  clearEquipmentScheduleRule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearEquipmentScheduleRuleMutationResult = NonNullable<Awaited<ReturnType<typeof clearEquipmentScheduleRule>>>

    export type ClearEquipmentScheduleRuleMutationError = void

    /**
 * @summary Clear a tag's own schedule rule
 */
export const useClearEquipmentScheduleRule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearEquipmentScheduleRule>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearEquipmentScheduleRule>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getClearEquipmentScheduleRuleMutationOptions(options), queryClient);
    }

export const getListSiteAreasUrl = (siteId: string,) => {




  return `/api/sites/${siteId}/areas`
}

/**
 * Every asset area named on the register, with the environment SET a
 * manager gave it. A tag with no environment of its own runs on its
 * area's.
 *
 * **Auth:** viewer floor + site claim.
 * @summary A site's asset areas and their environment
 */
export const listSiteAreas = async (siteId: string, options?: RequestInit): Promise<SiteAreaDTO[]> => {

  return customFetch<SiteAreaDTO[]>(getListSiteAreasUrl(siteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSiteAreasQueryKey = (siteId: string,) => {
    return [
    `/api/sites/${siteId}/areas`
    ] as const;
    }


export const getListSiteAreasQueryOptions = <TData = Awaited<ReturnType<typeof listSiteAreas>>, TError = void>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAreas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSiteAreasQueryKey(siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteAreas>>> = ({ signal }) => listSiteAreas(siteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSiteAreas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSiteAreasQueryResult = NonNullable<Awaited<ReturnType<typeof listSiteAreas>>>
export type ListSiteAreasQueryError = void


export function useListSiteAreas<TData = Awaited<ReturnType<typeof listSiteAreas>>, TError = void>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAreas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteAreas>>,
          TError,
          Awaited<ReturnType<typeof listSiteAreas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSiteAreas<TData = Awaited<ReturnType<typeof listSiteAreas>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAreas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteAreas>>,
          TError,
          Awaited<ReturnType<typeof listSiteAreas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSiteAreas<TData = Awaited<ReturnType<typeof listSiteAreas>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAreas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A site's asset areas and their environment
 */

export function useListSiteAreas<TData = Awaited<ReturnType<typeof listSiteAreas>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteAreas>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSiteAreasQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertSiteAreaUrl = (siteId: string,
    name: string,) => {




  return `/api/sites/${siteId}/areas/${name}`
}

/**
 * Sets the environment SET of one asset area, creating the area when the
 * register does not name it yet.
 *
 * **Auth:** manager floor (manager or admin) + site claim.
 * @summary Set an asset area's environment
 */
export const upsertSiteArea = async (siteId: string,
    name: string,
    upsertSiteAreaRequest: UpsertSiteAreaRequest, options?: RequestInit): Promise<SiteAreaDTO> => {

  return customFetch<SiteAreaDTO>(getUpsertSiteAreaUrl(siteId,name),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertSiteAreaRequest)
  }
);}





export const getUpsertSiteAreaMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSiteArea>>, TError,{siteId: string;name: string;data: UpsertSiteAreaRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertSiteArea>>, TError,{siteId: string;name: string;data: UpsertSiteAreaRequest}, TContext> => {

const mutationKey = ['upsertSiteArea'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertSiteArea>>, {siteId: string;name: string;data: UpsertSiteAreaRequest}> = (props) => {
          const {siteId,name,data} = props ?? {};

          return  upsertSiteArea(siteId,name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertSiteAreaMutationResult = NonNullable<Awaited<ReturnType<typeof upsertSiteArea>>>
    export type UpsertSiteAreaMutationBody = UpsertSiteAreaRequest
    export type UpsertSiteAreaMutationError = void

    /**
 * @summary Set an asset area's environment
 */
export const useUpsertSiteArea = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertSiteArea>>, TError,{siteId: string;name: string;data: UpsertSiteAreaRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertSiteArea>>,
        TError,
        {siteId: string;name: string;data: UpsertSiteAreaRequest},
        TContext
      > => {
      return useMutation(getUpsertSiteAreaMutationOptions(options), queryClient);
    }

export const getGetEquipmentSummaryUrl = (params?: GetEquipmentSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/summary?${stringifiedParams}` : `/api/equipment/summary`
}

/**
 * Site scope is derived from the authenticated user's site claims (X-Site-Claims header).
 * Optionally narrow the summary to a single site by passing the `siteId` query param —
 * the site must be present in the caller's claims or the request is rejected.
 * @summary Get equipment summary counts for dashboard
 */
export const getEquipmentSummary = async (params?: GetEquipmentSummaryParams, options?: RequestInit): Promise<EquipmentSummaryResponseDTO> => {

  return customFetch<EquipmentSummaryResponseDTO>(getGetEquipmentSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquipmentSummaryQueryKey = (params?: GetEquipmentSummaryParams,) => {
    return [
    `/api/equipment/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEquipmentSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getEquipmentSummary>>, TError = ErrorResponse>(params?: GetEquipmentSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquipmentSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquipmentSummary>>> = ({ signal }) => getEquipmentSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquipmentSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquipmentSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getEquipmentSummary>>>
export type GetEquipmentSummaryQueryError = ErrorResponse


export function useGetEquipmentSummary<TData = Awaited<ReturnType<typeof getEquipmentSummary>>, TError = ErrorResponse>(
 params: undefined |  GetEquipmentSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquipmentSummary>>,
          TError,
          Awaited<ReturnType<typeof getEquipmentSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquipmentSummary<TData = Awaited<ReturnType<typeof getEquipmentSummary>>, TError = ErrorResponse>(
 params?: GetEquipmentSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquipmentSummary>>,
          TError,
          Awaited<ReturnType<typeof getEquipmentSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquipmentSummary<TData = Awaited<ReturnType<typeof getEquipmentSummary>>, TError = ErrorResponse>(
 params?: GetEquipmentSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get equipment summary counts for dashboard
 */

export function useGetEquipmentSummary<TData = Awaited<ReturnType<typeof getEquipmentSummary>>, TError = ErrorResponse>(
 params?: GetEquipmentSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipmentSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquipmentSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRecentDocumentLinksUrl = (params: ListRecentDocumentLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/document-links?${stringifiedParams}` : `/api/equipment/document-links`
}

/**
 * Newest first, with the tag each document landed on — so a matcher's work
 * can be checked against the thing it chose rather than an equipment id.
 *
 * Pass `linkedBy=Auto-match` to see only what filename matching placed.
 * That is the review surface for automatic matching: a link made by a
 * person is a decision already taken, one made by a filename is a guess
 * worth a glance.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary Documents recently attached to equipment at a site
 */
export const listRecentDocumentLinks = async (params: ListRecentDocumentLinksParams, options?: RequestInit): Promise<ListRecentDocumentLinksResponse> => {

  return customFetch<ListRecentDocumentLinksResponse>(getListRecentDocumentLinksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecentDocumentLinksQueryKey = (params?: ListRecentDocumentLinksParams,) => {
    return [
    `/api/equipment/document-links`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRecentDocumentLinksQueryOptions = <TData = Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError = ErrorResponse>(params: ListRecentDocumentLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecentDocumentLinksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentDocumentLinks>>> = ({ signal }) => listRecentDocumentLinks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecentDocumentLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentDocumentLinks>>>
export type ListRecentDocumentLinksQueryError = ErrorResponse


export function useListRecentDocumentLinks<TData = Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError = ErrorResponse>(
 params: ListRecentDocumentLinksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentDocumentLinks>>,
          TError,
          Awaited<ReturnType<typeof listRecentDocumentLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentDocumentLinks<TData = Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError = ErrorResponse>(
 params: ListRecentDocumentLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentDocumentLinks>>,
          TError,
          Awaited<ReturnType<typeof listRecentDocumentLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentDocumentLinks<TData = Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError = ErrorResponse>(
 params: ListRecentDocumentLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Documents recently attached to equipment at a site
 */

export function useListRecentDocumentLinks<TData = Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError = ErrorResponse>(
 params: ListRecentDocumentLinksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocumentLinks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecentDocumentLinksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListEquipmentForDocumentUrl = (params: ListEquipmentForDocumentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/document-coverage?${stringifiedParams}` : `/api/equipment/document-coverage`
}

/**
 * The reverse of the equipment detail view: from a certificate to the tags
 * it covers, rather than from a tag to its paperwork. A single certificate
 * can cover the better part of a plant, so this pages.
 *
 * Lives here rather than in document-svc because the tag, description,
 * area and zone exist only on this side — document-svc holds an opaque
 * owner id. `location` is the installation location falling back to the
 * plant area, matching `findLinkCandidates` so a tag reads the same on
 * both screens.
 *
 * `total` and `areaCount` both follow `search`, so the footer under a
 * filtered table can't contradict it. `areaCount` counts distinct plant
 * areas rather than installation locations — "across 5 areas" is a claim
 * about the plant.
 *
 * Prefer `total` over document-svc's `equipment_count` when showing a
 * count to a person: this one is a join against the register, so equipment
 * that has since been deleted is already gone from it.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary The equipment one document covers
 */
export const listEquipmentForDocument = async (params: ListEquipmentForDocumentParams, options?: RequestInit): Promise<ListEquipmentForDocumentResponse> => {

  return customFetch<ListEquipmentForDocumentResponse>(getListEquipmentForDocumentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEquipmentForDocumentInfiniteQueryKey = (params?: ListEquipmentForDocumentParams,) => {
    return [
    'infinite', `/api/equipment/document-coverage`, ...(params ? [params] : [])
    ] as const;
    }

export const getListEquipmentForDocumentQueryKey = (params?: ListEquipmentForDocumentParams,) => {
    return [
    `/api/equipment/document-coverage`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEquipmentForDocumentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listEquipmentForDocument>>, ListEquipmentForDocumentParams['offset']>, TError = ErrorResponse>(params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData, QueryKey, ListEquipmentForDocumentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEquipmentForDocumentInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEquipmentForDocument>>, QueryKey, ListEquipmentForDocumentParams['offset']> = ({ signal, pageParam }) => listEquipmentForDocument({...params, 'offset': pageParam ?? params?.['offset']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData, QueryKey, ListEquipmentForDocumentParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEquipmentForDocumentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listEquipmentForDocument>>>
export type ListEquipmentForDocumentInfiniteQueryError = ErrorResponse


export function useListEquipmentForDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipmentForDocument>>, ListEquipmentForDocumentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData, QueryKey, ListEquipmentForDocumentParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentForDocument>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentForDocument>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentForDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipmentForDocument>>, ListEquipmentForDocumentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData, QueryKey, ListEquipmentForDocumentParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentForDocument>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentForDocument>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentForDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipmentForDocument>>, ListEquipmentForDocumentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData, QueryKey, ListEquipmentForDocumentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The equipment one document covers
 */

export function useListEquipmentForDocumentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listEquipmentForDocument>>, ListEquipmentForDocumentParams['offset']>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData, QueryKey, ListEquipmentForDocumentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEquipmentForDocumentInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEquipmentForDocumentQueryOptions = <TData = Awaited<ReturnType<typeof listEquipmentForDocument>>, TError = ErrorResponse>(params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEquipmentForDocumentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEquipmentForDocument>>> = ({ signal }) => listEquipmentForDocument(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEquipmentForDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof listEquipmentForDocument>>>
export type ListEquipmentForDocumentQueryError = ErrorResponse


export function useListEquipmentForDocument<TData = Awaited<ReturnType<typeof listEquipmentForDocument>>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentForDocument>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentForDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentForDocument<TData = Awaited<ReturnType<typeof listEquipmentForDocument>>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentForDocument>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentForDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentForDocument<TData = Awaited<ReturnType<typeof listEquipmentForDocument>>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The equipment one document covers
 */

export function useListEquipmentForDocument<TData = Awaited<ReturnType<typeof listEquipmentForDocument>>, TError = ErrorResponse>(
 params: ListEquipmentForDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentForDocument>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEquipmentForDocumentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCountEquipmentForDocumentsUrl = (params: CountEquipmentForDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/document-coverage/counts?${stringifiedParams}` : `/api/equipment/document-coverage/counts`
}

/**
 * The number under "Linked to" in the document library, for a page of
 * documents at once.
 *
 * Lives here rather than in document-svc for the same reason
 * `listEquipmentForDocument` does, and for a second one that matters more:
 * a shared IECEx certificate is one stored object mapped to several sites,
 * and document-svc's link rows carry an opaque owner and no site. Counting
 * there reports every site's tags together. Only this service knows which
 * site an owner sits in, so only this count is site-scoped.
 *
 * Counts join the register, so a link that outlived the equipment it
 * points at is not counted. A document covering nothing at this site is
 * absent from `counts` rather than present as a zero — read a missing
 * document as zero.
 *
 * Ids beyond the ceiling are dropped rather than refused: the caller is
 * filling in a table it has already drawn.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary How many tags each document covers at a site
 */
export const countEquipmentForDocuments = async (params: CountEquipmentForDocumentsParams, options?: RequestInit): Promise<CountEquipmentForDocumentsResponse> => {

  return customFetch<CountEquipmentForDocumentsResponse>(getCountEquipmentForDocumentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountEquipmentForDocumentsQueryKey = (params?: CountEquipmentForDocumentsParams,) => {
    return [
    `/api/equipment/document-coverage/counts`, ...(params ? [params] : [])
    ] as const;
    }


export const getCountEquipmentForDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError = ErrorResponse>(params: CountEquipmentForDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountEquipmentForDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countEquipmentForDocuments>>> = ({ signal }) => countEquipmentForDocuments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountEquipmentForDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof countEquipmentForDocuments>>>
export type CountEquipmentForDocumentsQueryError = ErrorResponse


export function useCountEquipmentForDocuments<TData = Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError = ErrorResponse>(
 params: CountEquipmentForDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countEquipmentForDocuments>>,
          TError,
          Awaited<ReturnType<typeof countEquipmentForDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountEquipmentForDocuments<TData = Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError = ErrorResponse>(
 params: CountEquipmentForDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countEquipmentForDocuments>>,
          TError,
          Awaited<ReturnType<typeof countEquipmentForDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountEquipmentForDocuments<TData = Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError = ErrorResponse>(
 params: CountEquipmentForDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How many tags each document covers at a site
 */

export function useCountEquipmentForDocuments<TData = Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError = ErrorResponse>(
 params: CountEquipmentForDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countEquipmentForDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountEquipmentForDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLinkPickerEquipmentUrl = (params: ListLinkPickerEquipmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/link-picker?${stringifiedParams}` : `/api/equipment/link-picker`
}

/**
 * The reverse of `listEquipmentForDocument`: that lists what a document
 * already covers, this lists everything it could. One certificate can
 * cover as many tags as it applies to, so this pages and filters.
 *
 * Rows already on the document come back with `linked: true` rather than
 * being filtered out — a picker that silently omits them reads as the
 * register being incomplete, so the screen shows them and says why.
 *
 * `unlinkedOnly` narrows to equipment holding **no Certificate of
 * Conformity at all**, not merely equipment absent from this document.
 * That is the gap worth closing when filing one.
 *
 * `selectableIds` is every matching id not already on the document, capped
 * at the number a single `linkDocument` request can carry. It backs
 * "select all N matching" without the browser paging the whole register to
 * collect them; when `total` exceeds the cap, the screen has to say so.
 *
 * `areas`, `types` and `zones` are the dropdown values, drawn site-wide
 * rather than from the current filter — a dropdown that only offered what
 * the present filter matches could never be used to widen it.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary The register, for choosing what a document covers
 */
export const listLinkPickerEquipment = async (params: ListLinkPickerEquipmentParams, options?: RequestInit): Promise<ListLinkPickerEquipmentResponse> => {

  return customFetch<ListLinkPickerEquipmentResponse>(getListLinkPickerEquipmentUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLinkPickerEquipmentInfiniteQueryKey = (params?: ListLinkPickerEquipmentParams,) => {
    return [
    'infinite', `/api/equipment/link-picker`, ...(params ? [params] : [])
    ] as const;
    }

export const getListLinkPickerEquipmentQueryKey = (params?: ListLinkPickerEquipmentParams,) => {
    return [
    `/api/equipment/link-picker`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLinkPickerEquipmentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listLinkPickerEquipment>>, ListLinkPickerEquipmentParams['offset']>, TError = ErrorResponse>(params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData, QueryKey, ListLinkPickerEquipmentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLinkPickerEquipmentInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkPickerEquipment>>, QueryKey, ListLinkPickerEquipmentParams['offset']> = ({ signal, pageParam }) => listLinkPickerEquipment({...params, 'offset': pageParam ?? params?.['offset']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData, QueryKey, ListLinkPickerEquipmentParams['offset']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLinkPickerEquipmentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkPickerEquipment>>>
export type ListLinkPickerEquipmentInfiniteQueryError = ErrorResponse


export function useListLinkPickerEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listLinkPickerEquipment>>, ListLinkPickerEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData, QueryKey, ListLinkPickerEquipmentParams['offset']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkPickerEquipment>>,
          TError,
          Awaited<ReturnType<typeof listLinkPickerEquipment>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkPickerEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listLinkPickerEquipment>>, ListLinkPickerEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData, QueryKey, ListLinkPickerEquipmentParams['offset']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkPickerEquipment>>,
          TError,
          Awaited<ReturnType<typeof listLinkPickerEquipment>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkPickerEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listLinkPickerEquipment>>, ListLinkPickerEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData, QueryKey, ListLinkPickerEquipmentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The register, for choosing what a document covers
 */

export function useListLinkPickerEquipmentInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listLinkPickerEquipment>>, ListLinkPickerEquipmentParams['offset']>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData, QueryKey, ListLinkPickerEquipmentParams['offset']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLinkPickerEquipmentInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListLinkPickerEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError = ErrorResponse>(params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLinkPickerEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkPickerEquipment>>> = ({ signal }) => listLinkPickerEquipment(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLinkPickerEquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkPickerEquipment>>>
export type ListLinkPickerEquipmentQueryError = ErrorResponse


export function useListLinkPickerEquipment<TData = Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkPickerEquipment>>,
          TError,
          Awaited<ReturnType<typeof listLinkPickerEquipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkPickerEquipment<TData = Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLinkPickerEquipment>>,
          TError,
          Awaited<ReturnType<typeof listLinkPickerEquipment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLinkPickerEquipment<TData = Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The register, for choosing what a document covers
 */

export function useListLinkPickerEquipment<TData = Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError = ErrorResponse>(
 params: ListLinkPickerEquipmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkPickerEquipment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLinkPickerEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getFindLinkCandidatesUrl = (params: FindLinkCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/link-candidates?${stringifiedParams}` : `/api/equipment/link-candidates`
}

/**
 * Ranks the site's equipment against a document filename, so the linking
 * screen can offer a shortlist instead of asking someone to search a
 * register of thousands.
 *
 * Nothing inside the file is read. Both the filename and the register
 * values are reduced to upper-case alphanumerics before comparison, which
 * is what makes "IECEx BAS 04.0031" in the register match
 * "IECEx-BAS-04-0031.pdf" on disk. Two signals fire:
 *
 * - `TAG_IN_FILENAME` — the equipment's tag appears in the filename. The
 *   more specific signal, since a tag names one piece of equipment.
 * - `CERTIFICATE_IN_FILENAME` — its certificate number appears. A
 *   certificate is issued against a design, so `certificate_group` lists
 *   every tag at the site sharing it: linking only the first would leave
 *   the rest of a certified set looking uncertified.
 *
 * Very short tags are ignored — under four characters they appear inside
 * ordinary words once separators are stripped, and would attach documents
 * almost at random.
 *
 * Equipment of every status is considered. A decommissioned tag still owns
 * its certificates.
 *
 * Authorization: the caller's `X-Site-Claims` must include `siteId`.
 * @summary Equipment a document's filename points at
 */
export const findLinkCandidates = async (params: FindLinkCandidatesParams, options?: RequestInit): Promise<FindLinkCandidatesResponse> => {

  return customFetch<FindLinkCandidatesResponse>(getFindLinkCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindLinkCandidatesQueryKey = (params?: FindLinkCandidatesParams,) => {
    return [
    `/api/equipment/link-candidates`, ...(params ? [params] : [])
    ] as const;
    }


export const getFindLinkCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof findLinkCandidates>>, TError = ErrorResponse>(params: FindLinkCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findLinkCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindLinkCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findLinkCandidates>>> = ({ signal }) => findLinkCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findLinkCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindLinkCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof findLinkCandidates>>>
export type FindLinkCandidatesQueryError = ErrorResponse


export function useFindLinkCandidates<TData = Awaited<ReturnType<typeof findLinkCandidates>>, TError = ErrorResponse>(
 params: FindLinkCandidatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findLinkCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findLinkCandidates>>,
          TError,
          Awaited<ReturnType<typeof findLinkCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindLinkCandidates<TData = Awaited<ReturnType<typeof findLinkCandidates>>, TError = ErrorResponse>(
 params: FindLinkCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findLinkCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findLinkCandidates>>,
          TError,
          Awaited<ReturnType<typeof findLinkCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindLinkCandidates<TData = Awaited<ReturnType<typeof findLinkCandidates>>, TError = ErrorResponse>(
 params: FindLinkCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findLinkCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Equipment a document's filename points at
 */

export function useFindLinkCandidates<TData = Awaited<ReturnType<typeof findLinkCandidates>>, TError = ErrorResponse>(
 params: FindLinkCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findLinkCandidates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindLinkCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteEquipmentByIdsUrl = () => {




  return `/api/equipment/batch`
}

/**
 * @summary Delete multiple equipment items by IDs
 */
export const deleteEquipmentByIds = async (batchDeleteEquipmentRequestDTO: BatchDeleteEquipmentRequestDTO, options?: RequestInit): Promise<BatchDeleteEquipmentResponseDTO> => {

  return customFetch<BatchDeleteEquipmentResponseDTO>(getDeleteEquipmentByIdsUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchDeleteEquipmentRequestDTO)
  }
);}





export const getDeleteEquipmentByIdsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEquipmentByIds>>, TError,{data: BatchDeleteEquipmentRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEquipmentByIds>>, TError,{data: BatchDeleteEquipmentRequestDTO}, TContext> => {

const mutationKey = ['deleteEquipmentByIds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEquipmentByIds>>, {data: BatchDeleteEquipmentRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  deleteEquipmentByIds(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEquipmentByIdsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEquipmentByIds>>>
    export type DeleteEquipmentByIdsMutationBody = BatchDeleteEquipmentRequestDTO
    export type DeleteEquipmentByIdsMutationError = ErrorResponse

    /**
 * @summary Delete multiple equipment items by IDs
 */
export const useDeleteEquipmentByIds = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEquipmentByIds>>, TError,{data: BatchDeleteEquipmentRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEquipmentByIds>>,
        TError,
        {data: BatchDeleteEquipmentRequestDTO},
        TContext
      > => {
      return useMutation(getDeleteEquipmentByIdsMutationOptions(options), queryClient);
    }

export const getPurgeSiteEquipmentUrl = (siteId: string,) => {




  return `/api/equipment/site/${siteId}/purge`
}

/**
 * Empties a site's equipment register while the site itself stays in
 * place. One `equipment.deleted` event goes out per row, so inspection-svc
 * and defect-svc drop the inspections and defects attached to those rows —
 * the same cascade a site deletion triggers. Documents, site members and
 * the site record are untouched.
 *
 * **Auth:** platform admin only. Unlike the ordinary batch delete, a
 * manager with a claim on the site cannot call this.
 * @summary Delete every equipment record on a site
 */
export const purgeSiteEquipment = async (siteId: string, options?: RequestInit): Promise<PurgeSiteEquipmentResponseDTO> => {

  return customFetch<PurgeSiteEquipmentResponseDTO>(getPurgeSiteEquipmentUrl(siteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPurgeSiteEquipmentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purgeSiteEquipment>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof purgeSiteEquipment>>, TError,{siteId: string}, TContext> => {

const mutationKey = ['purgeSiteEquipment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purgeSiteEquipment>>, {siteId: string}> = (props) => {
          const {siteId} = props ?? {};

          return  purgeSiteEquipment(siteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurgeSiteEquipmentMutationResult = NonNullable<Awaited<ReturnType<typeof purgeSiteEquipment>>>

    export type PurgeSiteEquipmentMutationError = ErrorResponse

    /**
 * @summary Delete every equipment record on a site
 */
export const usePurgeSiteEquipment = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purgeSiteEquipment>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purgeSiteEquipment>>,
        TError,
        {siteId: string},
        TContext
      > => {
      return useMutation(getPurgeSiteEquipmentMutationOptions(options), queryClient);
    }

export const getListEquipmentBatchUploadsUrl = (params: ListEquipmentBatchUploadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/equipment/excel/uploads?${stringifiedParams}` : `/api/equipment/excel/uploads`
}

/**
 * **Auth:** admin or manager + site claim on `siteId`. Admin bypasses
 * the site-claim check. Inspectors and viewers are not permitted —
 * listing in-flight batch imports is a register-management view.
 * @summary List all batch uploads for a site
 */
export const listEquipmentBatchUploads = async (params: ListEquipmentBatchUploadsParams, options?: RequestInit): Promise<EquipmentBatchUploadDTO[]> => {

  return customFetch<EquipmentBatchUploadDTO[]>(getListEquipmentBatchUploadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEquipmentBatchUploadsQueryKey = (params?: ListEquipmentBatchUploadsParams,) => {
    return [
    `/api/equipment/excel/uploads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEquipmentBatchUploadsQueryOptions = <TData = Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError = ErrorResponse>(params: ListEquipmentBatchUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEquipmentBatchUploadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEquipmentBatchUploads>>> = ({ signal }) => listEquipmentBatchUploads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEquipmentBatchUploadsQueryResult = NonNullable<Awaited<ReturnType<typeof listEquipmentBatchUploads>>>
export type ListEquipmentBatchUploadsQueryError = ErrorResponse


export function useListEquipmentBatchUploads<TData = Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError = ErrorResponse>(
 params: ListEquipmentBatchUploadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentBatchUploads>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentBatchUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentBatchUploads<TData = Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError = ErrorResponse>(
 params: ListEquipmentBatchUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentBatchUploads>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentBatchUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentBatchUploads<TData = Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError = ErrorResponse>(
 params: ListEquipmentBatchUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all batch uploads for a site
 */

export function useListEquipmentBatchUploads<TData = Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError = ErrorResponse>(
 params: ListEquipmentBatchUploadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentBatchUploads>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEquipmentBatchUploadsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getProcessEquipmentBatchUploadUrl = (uploadId: string,) => {




  return `/api/equipment/excel/uploads/${uploadId}/process`
}

/**
 * Called after the user reviews validation results to commit the
 * import. Validation runs automatically when the document.uploaded
 * event is received.
 *
 * **Auth:** admin or manager + site claim on the upload's site.
 * Admin bypasses the site-claim check.
 * @summary Confirm and import an already-validated batch upload
 */
export const processEquipmentBatchUpload = async (uploadId: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getProcessEquipmentBatchUploadUrl(uploadId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProcessEquipmentBatchUploadMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processEquipmentBatchUpload>>, TError,{uploadId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof processEquipmentBatchUpload>>, TError,{uploadId: string}, TContext> => {

const mutationKey = ['processEquipmentBatchUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof processEquipmentBatchUpload>>, {uploadId: string}> = (props) => {
          const {uploadId} = props ?? {};

          return  processEquipmentBatchUpload(uploadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProcessEquipmentBatchUploadMutationResult = NonNullable<Awaited<ReturnType<typeof processEquipmentBatchUpload>>>

    export type ProcessEquipmentBatchUploadMutationError = ErrorResponse

    /**
 * @summary Confirm and import an already-validated batch upload
 */
export const useProcessEquipmentBatchUpload = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof processEquipmentBatchUpload>>, TError,{uploadId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof processEquipmentBatchUpload>>,
        TError,
        {uploadId: string},
        TContext
      > => {
      return useMutation(getProcessEquipmentBatchUploadMutationOptions(options), queryClient);
    }

export const getExportEquipmentExcelUrl = () => {




  return `/api/equipment/excel`
}

/**
 * @summary Export equipment list as an Excel template
 */
export const exportEquipmentExcel = async ( options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getExportEquipmentExcelUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportEquipmentExcelQueryKey = () => {
    return [
    `/api/equipment/excel`
    ] as const;
    }


export const getExportEquipmentExcelQueryOptions = <TData = Awaited<ReturnType<typeof exportEquipmentExcel>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportEquipmentExcel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportEquipmentExcelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportEquipmentExcel>>> = ({ signal }) => exportEquipmentExcel({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportEquipmentExcel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportEquipmentExcelQueryResult = NonNullable<Awaited<ReturnType<typeof exportEquipmentExcel>>>
export type ExportEquipmentExcelQueryError = ErrorResponse


export function useExportEquipmentExcel<TData = Awaited<ReturnType<typeof exportEquipmentExcel>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportEquipmentExcel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportEquipmentExcel>>,
          TError,
          Awaited<ReturnType<typeof exportEquipmentExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportEquipmentExcel<TData = Awaited<ReturnType<typeof exportEquipmentExcel>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportEquipmentExcel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportEquipmentExcel>>,
          TError,
          Awaited<ReturnType<typeof exportEquipmentExcel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportEquipmentExcel<TData = Awaited<ReturnType<typeof exportEquipmentExcel>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportEquipmentExcel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export equipment list as an Excel template
 */

export function useExportEquipmentExcel<TData = Awaited<ReturnType<typeof exportEquipmentExcel>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportEquipmentExcel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportEquipmentExcelQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListEquipmentFieldMetadataUrl = () => {




  return `/api/equipment/field-metadata`
}

/**
 * Per-field metadata for every equipment field that either the validation
 * engine owns a rule for or the registry gives a hint to (CTE-238,
 * CTE-243…259): the control to render (a constrained SELECT for a
 * closed-enum field, a pattern-validated input for a rule with no small
 * enum, a plain FREETEXT input for a hinted passthrough field), the
 * restricted value set for a SELECT, and the field's label + one-line hint.
 * The create/edit form and details cards read this so both their pickers and
 * their help text come straight from the engine + field registry — a
 * restricted input can never offer a value the engine would reject, and a
 * free-text field's tooltip has one source of truth instead of a client-side
 * copy that drifts. Static metadata, not site-scoped.
 * @summary Field metadata for the create/edit form and details cards
 */
export const listEquipmentFieldMetadata = async ( options?: RequestInit): Promise<EquipmentFieldMetadataListDTO> => {

  return customFetch<EquipmentFieldMetadataListDTO>(getListEquipmentFieldMetadataUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEquipmentFieldMetadataQueryKey = () => {
    return [
    `/api/equipment/field-metadata`
    ] as const;
    }


export const getListEquipmentFieldMetadataQueryOptions = <TData = Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEquipmentFieldMetadataQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>> = ({ signal }) => listEquipmentFieldMetadata({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEquipmentFieldMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>>
export type ListEquipmentFieldMetadataQueryError = ErrorResponse


export function useListEquipmentFieldMetadata<TData = Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentFieldMetadata>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentFieldMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentFieldMetadata<TData = Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEquipmentFieldMetadata>>,
          TError,
          Awaited<ReturnType<typeof listEquipmentFieldMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEquipmentFieldMetadata<TData = Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Field metadata for the create/edit form and details cards
 */

export function useListEquipmentFieldMetadata<TData = Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEquipmentFieldMetadata>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEquipmentFieldMetadataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







